import PropTypes from 'prop-types';

import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const PriceComponent = ({ price }) => {
  const theme = useTheme();
  const color = theme.palette.custom.communityPrice;

  if (!price) return null;

  return (
    <>
      <Typography component="span" color={color}>
        ${price}
      </Typography>
      <Typography component="span">&nbsp;•&nbsp;</Typography>
    </>
  );
};

PriceComponent.propTypes = {
  price: PropTypes.string,
};

export default PriceComponent;
